var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "family-group-search" },
    [
      _c(
        "v-autocomplete",
        _vm._b(
          {
            staticClass: "p-0 new-ux-scroll family-group-search__field",
            attrs: {
              id: "family-group-search",
              value: _vm.selectedId,
              items: _vm.items,
              loading: _vm.loading,
              filter: _vm.customFilter,
              "menu-props": { offsetY: true },
              "item-value": "id",
              "item-text": "label",
              autocomplete: "off",
              rounded: "",
              placeholder: "Selecione um grupo familiar"
            },
            on: { change: _vm.handleChange },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(data) {
                  return [
                    _c(
                      "v-list-item-content",
                      [
                        _c("v-list-item-title", [
                          _vm._v(_vm._s(data.item.label))
                        ]),
                        _c(
                          "v-list-item-subtitle",
                          { staticClass: "az-text-secondary" },
                          [_vm._v(" " + _vm._s(data.item.subtitle) + " ")]
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          },
          "v-autocomplete",
          _vm.$attrs,
          false
        )
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }